'use client'

import { AccordionItem } from "@heroui/accordion"
import { Accordion } from "@heroui/accordion"
import { PLUGINS } from "./plugins"

export default function PluginsHelperAccordion() {
  return (
      <Accordion>
        {Object.entries(PLUGINS).map(([key, value]) => (
          <AccordionItem key={key} title={key}>
            <value.contentElement />
          </AccordionItem>
        ))}
      </Accordion>
  )
}
